<template>
  <div class="item" :id="`solution${index}`">
    <div class="item-header">
      <div class="item-header-title">WHY CHOOSE US</div>
      <div class="item-header-name">
        <span class="item-header-name-line" />
        <span>PACS影像混合云方案</span>
        <span class="item-header-name-line" />
      </div>
      <div class="item-header-desc">服务于智慧医疗、智慧制造，提高IT应用和管理</div>
    </div>

    <div class="item-content">
      <div class="child">
        <div class="child-top">
          <img :src="Img" />
        </div>
        <div class="child-bottom">
          <div class="table">
            <div class="table-row">
              <div class="table-col table-title">
                <div class="icon icon-user" />
                <span>客户痛点</span>
              </div>
              <div class="table-col table-info">
                <div>政策上，影像数据要求保存15年，胶片影像的废除和电子胶片收费标准和执行方案的各地陆续出台，互联网医院的行业趋势，分级诊疗、大数据辅助诊断的技术推动业务的发展；</div>
                <div>政策上，影像数据要求保存15年，胶片影像的废除和电子胶片收费标准和执行方案的各地陆续出台，互联网医院的行业趋势，分级诊疗、大数据辅助诊断的技术推动业务的发展；</div>
              </div>
            </div>
            <div class="table-row">
              <div class="table-col table-title">
                <div class="icon icon-cards" />
                <span>解决方案</span>
              </div>
              <div class="table-col table-info">
                <div>存储阵列+50Mb专线满足后续每天持续文件增量复制上云</div>
                <div>利用云端存储高可靠性，影像数据保存15年，OSS自动周期性向低频、归档存储转化</div>
                <div>云PACS实现实时查阅和分级诊疗等业务</div>
              </div>
            </div>
            <div class="table-row">
              <div class="table-col table-title">
                <div class="icon icon-vector" />
                <span>客户价值</span>
              </div>
              <div class="table-col table-info">
                <div>通过帮助客户将存量和增量的数据持续同步上云，使客户使用到云端的低成本存储和互联网医疗技术</div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>


    <div class="item-btn" @click="showBoard">详情了解</div>
  </div>
</template>

<script>
import Img from '../../assets/images/solution/img-5-1.png'

export default {
  data () {
    return {
      Img
    }
  },

  props: {
    index: {
      type: Number,
      required: true
    }
  },

  methods: {
    showBoard () {
      window.eventBus.$emit('boardShow')
    },
  }
}
</script>

<style lang="less" scoped>
.item-content {
  display: flex;
  flex-direction: column;
  align-items: center;
  margin: 20px 0px;

  @media (min-width: 1280px) and (max-width: 1680px){
    padding: 30px 0;
  }
        
  @media screen and (min-width: 1920px){
    padding: 40px 0;
  }
}
.item-btn {
  width: 96px;
  height: 28px;
  border-radius: 14px;
  background-color: #f45937;
  color: #fff;
  font-size: 9px;
  line-height: 28px;
  text-align: center;
  cursor: pointer;

  @media (min-width: 1280px) and (max-width: 1680px){
    width: 144px;
    height: 42px;
    border-radius: 21px;
    font-size: 14px;
    line-height: 42px;
    margin-top: 30px;
  }
        
  @media screen and (min-width: 1920px){
    width: 192px;
    height: 56px;
    border-radius: 28px;
    font-size: 18px;
    line-height: 56px;
    margin-top: 40px;
  }
}

.child {
  display: flex;
  flex-direction: column;
  background-size: 100% 100%;
  width: 100%;
  align-items: center;
  justify-content: center;
  &-top {
    padding: 34px 0px;
    img {
      width: 646px;
      height: 343px;

      @media (min-width: 1280px) and (max-width: 1680px){
        width: 969px;
        height: 514px;
      }
            
      @media screen and (min-width: 1920px){
        width: 1292px;
        height: 686px;
      }
    }
  }

  &-bottom {
    .table {
      &-row {
        display: flex;
      }
      &-col {
        border: 1px dashed #959595;
        height: 82px;
        display: flex;
        align-items: center;
        justify-content: center;

        @media (min-width: 1280px) and (max-width: 1680px){
          height: 123px;
        }
              
        @media screen and (min-width: 1920px){
          height: 164px;
        }
      }
      &-title {
        width: 200px;
        background-color: #eafaff;
        @media (min-width: 1280px) and (max-width: 1680px){
          width: 300px;
        }
              
        @media screen and (min-width: 1920px){
          width: 400px;
        }
        .icon {
          width: 16px;
          height: 16px;
          margin-right: 20px;

          @media (min-width: 1280px) and (max-width: 1680px){
            width: 24px;
            height: 24px;
            margin-right: 30px;
          }
                
          @media screen and (min-width: 1920px){
            width: 32px;
            height: 32px;
            margin-right: 40px;
          }
        }
        .icon-user {
          background: url('../../assets/images/solution/icon-user.png');
          background-size: 100% 100%;
        }
        .icon-cards {
          background: url('../../assets/images/solution/icon-cards.png');
          background-size: 100% 100%;
        }
        .icon-vector {
          background: url('../../assets/images/solution/icon-vector.png');
          background-size: 100% 100%;
        }
      }

      &-title:hover {
        color: #fff;
        background-color: #0077fe;
        .icon-user {
          background: url('../../assets/images/solution/icon-user-active.png');
          background-size: 100% 100%;
        }
        .icon-cards {
          background: url('../../assets/images/solution/icon-cards-active.png');
          background-size: 100% 100%;
        }
        .icon-vector {
          background: url('../../assets/images/solution/icon-vector-active.png');
          background-size: 100% 100%;
        }
      }
      &-info {
        width: 500px;
        display: flex;
        flex-direction: column;
        color: #959595;
        font-size: 9px;
        align-items: flex-start;
        padding: 0 20px;

        @media (min-width: 1280px) and (max-width: 1680px){
          width: 750px;
          font-size: 13.5px;
          padding: 0 30px;
        }
              
        @media screen and (min-width: 1920px){
          width: 1000px;
          font-size: 18px;
          padding: 0 40px;
        }

        div  {
          text-align: left;
        }
      }
    }
  }
}
</style>